import { useMemo, useState } from "react";
import api, { formatApiErrorDetail } from "../../lib/api";
import { toast } from "sonner";

const blankForm = () => ({
  tenant_id: "", period: new Date().toISOString().slice(0, 7),
  amount: 0, due_date: new Date().toISOString().slice(0, 10), notes: "",
});

export function InvoiceForm({ tenants, onDone, onCancel }) {
  const [form, setForm] = useState(blankForm);
  const active = useMemo(() => tenants.filter((t) => t.status === "active"), [tenants]);
  const pickTenant = (id) => {
    const rent = tenants.find((t) => t.id === id)?.rent_amount || 0;
    setForm({ ...form, tenant_id: id, amount: rent });
  };
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/rent-invoices", { ...form, amount: Number(form.amount) });
      toast.success("Invoice created");
      onDone();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  return (
    <form onSubmit={submit} className="bg-white border border-slate-200 p-6 grid md:grid-cols-3 gap-4" data-testid="invoice-form">
      <select required className="border border-slate-300 px-4 py-2.5" value={form.tenant_id} data-testid="inv-tenant"
              onChange={(e) => pickTenant(e.target.value)}>
        <option value="">Select tenant…</option>
        {active.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
      </select>
      <input required type="month" data-testid="inv-period" className="border border-slate-300 px-4 py-2.5"
             value={form.period} onChange={(e) => setForm({ ...form, period: e.target.value })} />
      <input required type="number" min="0" placeholder="Amount ₹" data-testid="inv-amount"
             className="border border-slate-300 px-4 py-2.5"
             value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} />
      <input required type="date" data-testid="inv-due" className="border border-slate-300 px-4 py-2.5"
             value={form.due_date} onChange={(e) => setForm({ ...form, due_date: e.target.value })} />
      <input placeholder="Notes" className="border border-slate-300 px-4 py-2.5 md:col-span-2"
             value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
      <div className="md:col-span-3 flex gap-3">
        <button data-testid="inv-save" className="bg-slate-900 text-white px-6 py-2.5">Save</button>
        <button type="button" onClick={onCancel} className="bg-slate-100 px-6 py-2.5">Cancel</button>
      </div>
    </form>
  );
}
